import type {CorePlugin, SingleComponentPlugin} from '../../types'
import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'
import {pack} from './pack'
import {unpack} from './unpack'

export const defaultsSingleComponentPlugin = {
    name: 'DefaultsPlugin',
    pack,
    unpack
} satisfies SingleComponentPlugin

export const defaultsPlugin: CorePlugin = createPluginFromSingleComponentPlugin(defaultsSingleComponentPlugin)
